import { bool, func, string } from 'prop-types';

import Indicator from './Indicator';
import { Label, DisplayName, Input } from './style';

/**
 * EntityToggle renders a label element with an entity artwork image,
 * a hidden label and a hidden radio input. Clicking the label/image will trigger
 * the onChange method on the input.
 *
 * @method      EntityToggle
 * @param       {Object}     props React props
 * @param       {String}     props.id Entity ID
 * @param       {String}     props.displayName Entity display name
 * @param       {String}     props.name Use to specify the radio group name attribute
 * @param       {String}     props.color Color used for the artwork borders
 * @param       {Function}   props.handleChange To call on a 'change' event on the input
 * @param       {Boolean}    props.isSelected Is this entity selected?
 * @constructor
 */
function EntityToggle(props) {
  const { id, displayName, name, color, handleChange, isSelected } = props;

  return (
    <Label selected={isSelected} color={color} data-pw="entity-toggle">
      <Indicator active={isSelected} color={color} />
      <DisplayName>{displayName || id}</DisplayName>
      <Input
        type="radio"
        name={name}
        value={id}
        id={id}
        checked={isSelected}
        onChange={handleChange}
      />
    </Label>
  );
}

EntityToggle.propTypes = {
  displayName: string,
  id: string.isRequired,
  color: string.isRequired,
  name: string.isRequired,
  isSelected: bool.isRequired,
  handleChange: func.isRequired,
};

export default EntityToggle;
